import React from 'react';
import { Box, Typography, CircularProgress, Stack } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Overlay = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  animation: `${fadeIn} 0.2s ease-in-out`
}));

const PopupContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: '32px',
  maxWidth: '400px',
  padding: '40px',
  [theme.breakpoints.down('sm')]: {
    padding: '32px 24px'
  }
}));

const LoadingTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Inter', sans-serif",
  fontSize: '20px',
  fontWeight: 600,
  color: '#0f172a',
  textAlign: 'center'
}));

const LoadingMessage = styled(Typography)(({ theme }) => ({
  fontFamily: "'Inter', sans-serif",
  fontSize: '15px',
  fontWeight: 400,
  color: '#64748b',
  textAlign: 'center',
  lineHeight: 1.6
}));

const LoadingPopup = ({ open }) => {
  if (!open) return null;

  return (
    <Overlay>
      <PopupContainer>
        <CircularProgress 
          size={60} 
          thickness={3}
          sx={{
            color: '#0f172a'
          }}
        />

        <Stack gap="12px" alignItems="center">
          <LoadingTitle>
            Creating Your Website
          </LoadingTitle>
          <LoadingMessage>
            Please wait while we set up your website. This will only take a moment.
          </LoadingMessage>
        </Stack>
      </PopupContainer>
    </Overlay>
  );
};

export default LoadingPopup;